import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import { AvatarModule } from 'primeng/avatar';
import { ProfitLossData, StockData } from '../../../app/company/company.model';
import { NumberFormatterUtil } from '../../utils/number-formatter.util';
import { Router } from '@angular/router';
import { EmptyStateComponent } from '../empty-state/empty-state.component';
import { InfoTooltipComponent } from '../info-tooltip/info-tooltip.component';
@Component({
  selector: 'mohlel-profit-loss-tabs',
  imports: [
    CommonModule,
    TranslateModule,
    TabsModule,
    AvatarModule,
    EmptyStateComponent,
    InfoTooltipComponent,
  ],
  templateUrl: './profit-loss-tabs.component.html',
  styleUrls: ['./profit-loss-tabs.component.scss'],
})
export class ProfitLossTabsComponent {
  title = input.required<string>();
  data = input.required<ProfitLossData>();
  showAvatar = input<boolean>(true);
  showSymbol = input<boolean>(true);

  private router = inject(Router);

  numberFormatterUtil = NumberFormatterUtil;

  onNavigate(item: StockData) {
    if (item.symbol) {
      this.router.navigate(['/sectors/company', item.id], {
        queryParams: {
          tab: 'profile',
        },
      });
    } else {
      this.router.navigate(['/sectors/', item.id]);
    }
  }
}
